import React from 'react';
import { AddonsConsumer } from '../../../../Addons';
import BasicAddonsListComponent from '../BasicAddonsList';

function BasicAddonsList(props) {
  return (
    <AddonsConsumer>
      {({
        actions: { getAdditionalOutputs, getCaptions, getFormattedAddon }
      }) =>
      <BasicAddonsListComponent
        getAdditionalOutputs={getAdditionalOutputs}
        getCaptions={getCaptions}
        getFormattedAddon={getFormattedAddon}
        {...props} />}


    </AddonsConsumer>);

}

export default BasicAddonsList;